import { render, staticRenderFns } from "./ProductMobile.vue?vue&type=template&id=7e8b9d18&scoped=true&"
import script from "./ProductMobile.vue?vue&type=script&lang=js&"
export * from "./ProductMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductMobile.vue?vue&type=style&index=0&id=7e8b9d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b9d18",
  null
  
)

export default component.exports